import React, { Component} from 'react';
import { translate } from 'react-i18next';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import swal from 'sweetalert';
import { functionalCriterial, lookups, lookupsType, nationalCentersOption, patientOffer, personSearch } from '../../libs/services';
import LabelForm from '../../components/LabelForm';
import AutocompleteForm from '../../components/AutocompleteForm';
import SearchIcon from '../../components/SearchIcon';
import ModalPersonSearch from '../../containers/generics/modal_person_search';
import Button from '../../components/Button';
import ModalSearchImss from '../components/ModalSearchImss';
import InputForm from '../../components/InputForm';
import SelectForm from '../../components/SelectForm';
import PlusButton from '../../components/PlusButton';
import InputMaskForm from '../../components/InputMaskForm';
import ModalCenter from '../../containers/generics/modalCenter';
import { validString } from '../../libs/functions';
import moment from 'moment';


class PatientData extends Component{

	constructor(props) {
		super(props);

        this.onAutocompleteSearch = this.onAutocompleteSearch.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.person_search = this.person_search.bind(this);
        this.clear = this.clear.bind(this);
        this.openSearchImss = this.openSearchImss.bind(this);
        this.availableEdit = this.availableEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getNationalCenters = this.getNationalCenters.bind(this);
        this.updatePatientSearch = this.updatePatientSearch.bind(this);
        this.rhGroupHandleChange = this.rhGroupHandleChange.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);

		this.addCenter = this.addCenter.bind(this);


		this.state = { 
            imss_search:{value:'NO'},
            national_center_id:"",
            load_search:false,
            options:[],
            edit_patient:false,
            patient_name:"",
            patient_lastname1:"",
            patient_lastname2:"",
            patient_sex:"",
            patient_birthday:"",
            health_facility_id:"",
            health_facilities:[],
            national_centers:[],
            facility_section_id:"",
            facility_sections:[],
            national_name:"",
            relationship:"",
            relationships:[],
            social_number:"",
            no_file:"",
            rh_group:"",
            rhGroup:[],
	    	patient_number:"",
            patient_idee:"",
            fromImss:false,
            load_national_center:false,
            lookup_group:"",
	    	lookup_rh:"",
            lookup_value:"",


	    	isLoading: false,
	    	observations:false,
	    	disablePatient: false,

	    	requestedSelected:[],
	    	indice:-1,
	    	emergency_levels:[],
			
			user_add_center:"",
			pac_usr_npm:{},
			patient_id:"",
            person_id:"",
			index_nc_id:-1
	    }
	}

	async componentDidMount() {
		this.props.onRef(this);

        var options = [];
        var response = await functionalCriterial('IMSS_SEARCH');
        if(response !== undefined){
            this.setState({imss_search: response});
        }

		response = await lookups('health_services', 'true');
        if(response !== undefined){
            options = [];
            options = response.map((res)=>{
                var obj = {
                    value:res.id,
                    text:res.name
                }
                return obj;
            });
            this.setState({facility_sections:options});
        }

        response = await functionalCriterial('USER_ADD_CENTER');
        if(response !== undefined){
            this.setState({
                user_add_center: response.value
            });
        }

        response = await functionalCriterial('PAC_USR_NPM');
        if(response !== undefined){
            this.setState({
                pac_usr_npm: response.value
            });

            if(response.value === 'NO'){	
                if(this.props.location.pathname.indexOf('new') !== -1){
                    this.props.getNextPatient();
                }                
            }
        }
        
        response = await lookups('FAMILIAR_RELATIONSHIP', 'false');
        if(response){
            options = [];
            options = response.map((res)=>{
                var obj = {
                    value:res.key,
                    text:res.name
                }
                return obj;
            });
            this.setState({relationships: options});
        }

		response = await lookups('PATIENT_EMERGENCY_LEVEL', 'false');
        if(response){
            this.setState({emergency_levels: response});
        }

        response = await lookupsType('blood_group_rh');
        if(response){
            options = [];
            options = response.map((res)=>{
                var obj = {
                    value:res.name,
                    text:res.name
                }
                return obj;
            });
            this.setState({rhGroup: options});
        }

		this.getNationalCenters();
	}

    componentWillUnmount() {
	    this.props.onRef(null)
	}

    handleChange(e){
        if(e.target.name === 'patient_name' || e.target.name === 'patient_lastname1' || e.target.name === 'patient_lastname2'){
			if(e.target.value === ""){
                this.setState({[e.target.name]: e.target.value});
            }
            if(validString(e.target.value, 'patient')){
				this.setState({[e.target.name]: e.target.value});
			}
		}else{
            this.setState({[e.target.name]: e.target.value});
        }

        if(e.target.name === 'rh_group'){
            this.rhGroupHandleChange(e.target.value);
        }
    }

	async getNationalCenters(){
        var response = await nationalCentersOption(sessionStorage.getItem("health_facilities_id"), 'origin_patients');
        if(response){
            response.forEach((res)=>{
                res.values = res.name;
            });
            this.setState({national_centers: response});
  
            if(this.state.national_center_id !== ""){
                this.setNationalCenter(this.state.national_center_id);
            }
        }
	}

    setNationalCenter(center){
        var index = this.state.national_centers.findIndex(item => item.id === center);
        if(index !== -1){
            this.setState({
                index_nc_id:index,
            });
        }
    }

    async onAutocompleteSearch(query){
	    this.setState({load_search: true});
        var response = await personSearch(query);
        if(response){
            for (var i = 0; i < response.length; i++) {
                if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
                    response[i].values = response[i].lastname1 +' '+ response[i].lastname2+' '
                                        +response[i].names +' '+ 
                                        (response[i].birthday !== null ? response[i].birthday : '');
                
                }else{
                    response[i].values = response[i].lastname1 +' '+ response[i].names +' '+ 
                                        (response[i].birthday !== null ? response[i].birthday : '');
                }


                if(response[i].document_type_value !== null){
                    response[i].values +=' '+response[i].document_type_value;
                }

                if(response[i].document_number !== null){
                    response[i].values +=' '+response[i].document_number;
                }

                if(response[i].number !== null){
                    response[i].values += ' '+response[i].number
                }
                response[i].id = response[i].person_id;
            };

            this.setState({load_search:false, options: response});


            setTimeout(()=>{
                if(this.modal_person_search.state.show){
                    var id = '';
                    this.modal_person_search.state.list.map((p)=>{
                        if(p.check){
                            id = p.person_id;
                        }
                    });

                    var index = this.state.options.findIndex(obj => 
                        parseInt(obj.person.id) === parseInt(id)
                    );

                    if(index !== -1){
                        this.updateState([this.state.options[index]]);
                        this.modal_person_search.handleClose();
                        this.props.waiting.handleClose();
                    }else{
                        swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
                        this.modal_person_search.handleClose();
                        this.props.waiting.handleClose();
                    }
                }
                
            }, 500);
        }
	}

    onAutocompleteChange(values, name){
	    let value = '';
	    if (values.length > 0) {
			value = values[0];
            
            if(name === 'patient'){
                this.updatePatientSearch(value);
            }
            
            if(name === 'nationalCenterId'){
                var index = this.state.national_centers.findIndex(obj => obj.id === value.id);
            
                this.setState({national_center_id: value.id, index_nc_id:index});
            }
	    }
	}

    async updatePatientSearch(value){
        //this.props.onChange({target:{name:'blockFieldsPatient', value:true}});
        this.setState({edit_patient:false, disablePatient:false});

        if(value.patient_id !== 0){
            var response = await patientOffer(value.patient_id);
            if(response !== undefined){
                this.setData(response)			 			
            }
        }else{
            var item = {
                person:{
                    birthday:value.FECHA_NACIMIENTO.DateTime,
                    names: value.NOMBRE,
                    lastname1: value.PRIMER_APELLIDO,
                    lastname2: value.SEGUNDO_APELLIDO,
                    id: value.patient_id,
                    social_number: value.NSS,
                    sex: value.SEXO === 'F' ? 'MUJER' : value.SEXO === 'M' ? 'HOMBRE' : '',
                    national_center_id:"",
                    idee: value.IDEE,
                    lookup_group:"",
                    lookup_rh:""

                },
                patient:{
                    id: value.patient_id,
                    patient_number: "",
                    number:""
                }
            }

            this.setState({fromImss:true});

            this.setData(item);
        }
    }

    person_search(){
		this.modal_person_search.handleShow('Paciente', 'patients');
	}
	
    clear(e){
		e.preventDefault();
       
        this.autocomplete_patient.refs._patient._instance.clear();
        //this.props.onChange({target:{name:'blockFieldsPatient', value:true}});
		this.setState({
            fromImss:false,
            disablePatient:false,
            edit_patient:true,
            patient_name:"",
            patient_lastname1:"",
            patient_lastname2:"",
            patient_sex:"",
            patient_birthday:"",
            health_facility_id:"",
            facility_section_id:"",
            national_name:"",
            relationship:"",
            social_number:"",
            no_file:"",
            rh_group:"",
            patient_number:"",
            patient_idee:"",
            lookup_group:"",
            lookup_rh:"",
            lookup_value:"",
            patient_id:""
        });
	}

    openSearchImss(){
        this.modal_search_imss.handleShow()
    }

    availableEdit(e){
       this.setState({disablePatient:!e.target.checked});
	}

	rhGroupHandleChange(value){
        var index = this.state.rhGroup.findIndex(item => item.name === value);
        if(index !== -1){
            this.setState({
                lookup_group:this.state.rhGroup[index].key_group,
                lookup_rh: this.state.rhGroup[index].key_rh
            });
        }
	}

    getData(obj){
        obj = {...obj, offering_cells:{
            ...obj.offering_cells,
            patient_id:this.state.patient_id,
            national_center_id: this.state.national_center_id,
            patient_relationship: this.state.relationship,
            health_service:this.state.national_name,
        },patient:{
            ...obj.patient,
            number: this.state.patient_number,
            patient_number: this.state.patient_number,
            person:{
                ...obj.patient.person,
                person_type:'PATIENT',
                social_number:this.state.social_number,
                names:this.state.patient_name,
                lastname1:this.state.patient_lastname1,
                birthday:this.state.patient_birthday !== "" ? this.state.patient_birthday.length === 10 ? 
                    moment(this.state.patient_birthday, 'DD/MM/YYYY').format('YYYY-MM-DD') : "invalid date" :"",
                sex:this.state.patient_sex,
                lastname2:this.state.patient_lastname2,
                national_center_id:this.state.national_center_id,
                lookup_group:this.state.lookup_group,
                lookup_rh:this.state.lookup_rh                
            }
        }};

        return obj;
    }

    setData(item){
        if(item.person.lookup_group !== null){
            var rhGroup = item.person.lookup_group+' '+
                            (item.person.lookup_rh === 'POSITIVO' ? '+' : item.person.lookup_rh === 'NEGATIVO' ? '-' : '')
            this.rhGroupHandleChange(rhGroup);
        }
        this.setState({
            patient_id:item.patient.id,
            person_id:item.person.id,
            patient_name:item.person.names,
            patient_lastname1:item.person.lastname1,
            patient_lastname2:item.person.lastname2,
            patient_sex:item.person.sex,
            patient_birthday:item.person.birthday !== null && item.person.birthday !== "" ? moment(item.person.birthday).format('DD/MM/YYYY') : "",
            rh_group:rhGroup,
            social_number:item.person.social_number,
            patient_number:item.patient.patient_number,
            idee:item.person.idee
        });        
    }
	
	addCenter(){
		this.modal_add_center.handleShow();
	}

	render(){
		const { t } = this.props;
		return(
			<fieldset className="col-xs-12 form-group no-padding">
				<legend>Datos del Paciente</legend>
				<div className="col-xs-12 no-padding">
					<div className="col-xs-7">
                        <LabelForm text={t('content.generics.buttons.search')} />
                        <AutocompleteForm 
                            minLength={3}
                            id="patient"
                            disabled={this.state.disablePatient}
                            options={this.state.options}
                            handleSearch={this.onAutocompleteSearch}
                            handleChange={this.onAutocompleteChange}
                            reference="_patient"
                            loading={this.state.load_search}
                            placeholder="Buscar por apellidos más nombre o número de documento..."
                            onRef={ref => this.autocomplete_patient = ref}
                        />
					</div>
					<div className="col-xs-12 col-sm-1">
                        <SearchIcon actionSearch={this.person_search} />
					</div>
					<div className="col-xs-12 col-sm-4">
                        <Button 
                            styles={{marginTop:"16px",marginLeft:"5px"}}
                            class="btn-info button-min"
                            action={this.clear}
                            disabled={this.state.disablePatient}
                            text="LIMPIAR"
                        />
						{this.state.imss_search.value === 'YES' &&
                            <Button 
                                styles={{marginTop:"16px",marginLeft:"5px", marginLeft:'8px'}}
                                class="btn-info button-min"
                                action={this.openSearchImss}
                                disabled={this.state.disablePatient}
                                text="Busqueda IMSS"
                            />
						}
					</div>
				</div>
				{this.state.edit_patient &&
                    <div className="col-xs-12">
                        <input className="form-check-input" type="checkbox" name="blockFields" 
                            onKeyPress={(e) => this.props.validate(e)}
                            value={ this.state.disablePatient} 
                            onChange={(e)=>this.availableEdit(e)} style={{marginRight:'5px'}}/>
                        <LabelForm text="Editar Datos" />
                    </div>
			    }
                {this.props.fields.map((field, i)=>
                    field.section_key === 'PATIENT' ?
                        field.print ?
                            field.key === 'PATIENT_NAME' ?
                                <div className="col-xs-12 col-md-4" key={i}>
                                    <LabelForm text={t('content.offers.form.names')} />                                    
                                    <InputForm 
                                        id="patient_name"
                                        value={this.state.patient_name}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        maxLength={100}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'PATIENT_LASTNAME1' ?
                                <div className="col-xs-12 col-md-2" key={i}>
                                    <LabelForm text={t('content.offers.form.lastname1')} />
                                    <InputForm 
                                        id="patient_lastname1"
                                        value={this.state.patient_lastname1}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        maxLength={50}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'PATIENT_LASTNAME2' ?
                                <div className="col-xs-12 col-md-2" key={i}>
                                    <LabelForm text={t('content.offers.form.lastname2')} />
                                    <InputForm 
                                        id="patient_lastname2"
                                        value={this.state.patient_lastname2}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        maxLength={50}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'PATIENT_SEX' ?
                                <div className="col-xs-12 col-sm-2" key={i}>
                                    <LabelForm text={t('content.offers.form.gender')} />                                    
                                    <SelectForm 
                                        id="patient_sex"
                                        value={this.state.patient_sex}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                        options={[{value:'HOMBRE', text:'HOMBRE'}, {value:'MUJER', text:'MUJER'}]}
                                    />
                                </div>
                            : field.key === 'PATIENT_BIRTHDAY' ?
                                <div className="col-xs-12 col-md-2" key={i}>
                                    <LabelForm text={t('content.offers.form.birthday')} />
                                    <InputMaskForm 
                                        id="patient_birthday"
                                        value={this.state.patient_birthday}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'NATIONAL_CENTER_ID' ?
                                this.state.hemored ? 
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.health_facility')} />
                                        <SelectForm 
                                            id="health_facility_id"
                                            value={this.state.health_facility_id}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            required={field.required}
                                            disabled={this.state.disablePatient}
                                            options={this.state.health_facilities}
                                        />
                                    </div>
                                :
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <div>
                                            <LabelForm text={t('content.offers.form.health_facility')} />
                                        </div>
                                        <div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
                                            <AutocompleteForm                                                 
                                                disabled={this.state.disablePatient}
                                                minLength={0}
                                                options={this.state.national_centers}
                                                validate={this.props.validate}
                                                handleChange={this.onAutocompleteChange}
                                                inputProps={{
                                                    name:"national_center_id",
                                                    id:"national_center_id",
                                                    required:field.required
                                                }}
                                                id="nationalCenterId"
                                                reference="_nationalCenterId"
                                                loading={this.state.load_national_center}
                                                selected={this.state.index_nc_id !== -1 ? [this.state.national_centers[this.state.index_nc_id]] : []}
                                                onRef={ref => this.autocomplete_national_center = ref}
                                            />
                                        </div>
                                        {this.state.user_add_center === 'YES' &&
                                            <div style={{width:'10%', display:'inline-block', textAlign:'center'}}>
                                                <PlusButton action={this.addCenter} />
                                            </div>
                                        }
                                    </div>
                            : field.key === 'PATIENT_SECTION_NAME' ?
                                this.state.hemored ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.service')} />
                                        <SelectForm 
                                            id="facility_section_id"
                                            value={this.state.facility_section_id}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            required={field.required}
                                            disabled={this.state.disablePatient}
                                            options={this.state.facility_sections}
                                        />
                                    </div>
                                : 
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.offers.form.service')} />
										{this.props.location.pathname.indexOf('offers') !== -1 ||  this.props.location.pathname.indexOf('cell_bank') !== -1 ?
                                            <SelectForm 
                                                id="national_name"
                                                value={this.state.national_name}
                                                handleChange={this.handleChange}
                                                validate={this.props.validate}
                                                required={field.required}
                                                disabled={this.state.disablePatient}
                                                options={this.state.facility_sections}
                                            />
										:
                                            <InputForm 
                                                    id="national_name"
                                                    value={this.state.national_name}
                                                    handleChange={this.handleChange}
                                                    validate={this.props.validate}
                                                    required={field.required}
                                                    disabled={this.state.disablePatient}
                                            />
										}
                                        
                                    </div>
                            : field.key === 'PATIENT_RELATIONSHIP' ?
                                <div className="col-xs-12 col-sm-2" key={i}>
                                    <LabelForm text={t('content.offers.form.relationship')} />
                                    <SelectForm 
                                        id="relationship"
                                        value={this.state.relationship}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        disabled={this.state.disablePatient}
                                        options={this.state.relationships}
                                    />
                                </div>
                            : field.key === 'SOCIAL_NUMBER' ?
                                <div className="col-xs-12 col-sm-2" key={i}>
                                    <LabelForm text="No. IMSS" />
                                    <InputForm 
                                        id="social_number"
                                        value={this.state.social_number}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        disabled={this.state.fromImss ? true : this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'CLINIC_HISTORY' ?
                                <div className="col-xs-12 col-md-2" key={i}>
                                    <LabelForm text={t('content.offers.form.no_file')} />
                                    <InputForm 
                                        id="no_file"
                                        value={this.state.no_file}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        disabled={this.state.disablePatient}
                                    />
                                </div>
                            : field.key === 'RH_GROUP' ?
                                <div className="col-xs-12 col-md-2" key={i}>
                                    <LabelForm text={t('content.offers.form.rh_group')} />
                                    <SelectForm 
                                        id="rh_group"
                                        value={this.state.rh_group}
                                        handleChange={this.handleChange}
                                        validate={this.props.validate}
                                        required={field.required}
                                        disabled={this.state.fromImss ? true : 
                                            this.state.disablePatient ? true :
                                            this.state.rh_group === null ? false :
                                            this.state.rh_group === "" ? false : true
                                        }
                                        options={this.state.rhGroup}
                                    />
                                </div>
                            
                            : field.key === 'PATIENT_NUMBER' ?
                                <div className="col-xs-12 col-sm-2" key={i}>
                                    <LabelForm text="Número de Paciente" />
                                    <InputForm 
                                        id="patient_number"
                                        value={this.state.patient_number}
                                        handleChange={this.handleChange}
                                        required={field.required}
                                        disabled={this.state.pac_usr_npm === 'NO' ? true : this.state.disablePatient}
                                    />
                                </div>
							: field.key === 'PATIENT_IDEE' ?
								<div className='col-xs-12 col-sm-2' key={i}>
									<LabelForm text="IDEE" />
                                    <InputForm 
                                        id="patient_idee"
                                        value={this.state.patient_idee}
                                        handleChange={this.handleChange}
                                        disabled={true}
                                    />
								</div>
                            :null
                        :null
                    :null
                )}
	
                
                
				<ModalPersonSearch 
                    {...this.props} 					
					updatePerson={this.onAutocompleteChange} 					
					search={this.onAutocompleteChange}
					persons={this.state.options}
                    onRef={ref => (this.modal_person_search = ref)} 
				/>
                <ModalSearchImss 
                    {...this.props}
                    updateState={this.onAutocompleteChange}
                    onRef={ref => this.modal_search_imss = ref}
                />
                
				<ModalCenter 
                    {...this.props} 
                    refresh={this.getNationalCenters} 
                    onRef={ref => (this.modal_add_center = ref)} 
                />
		    </fieldset>
		)
	}
}

export default translate('translations')(PatientData);